module.exports = __webpack_public_path__ + "static/media/logo.d19df142.svg";